<template>
  <div>
    <ServerError v-if="ServerError" />
    <v-snackbar
      v-model="showSnackBar"
      :color="appColor"
      right
      :timeout="timeout"
    >
      <v-layout wrap justify-center>
        <v-flex text-left align-self-center>{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <!--
      The per-role mobile drawers that used to live here are gone. They were a
      second, hard-coded copy of each sidebar: four roles had none at all, and
      the ones that existed had drifted from the desktop menu. The hamburger
      below now emits toggle-nav and the layout opens its own AppSidebar.
    -->







    <!-- SIDENAV -->
    <v-navigation-drawer
      v-model="sideNavRight"
      right
      fixed
      temporary
      width="220px"
      class="hidden-md-and-up"
      color="#FAFAFA"
    >
      <v-layout wrap>
        <v-flex v-for="(item, i) in headerItems" :key="i" xs12 text-center>
          <v-layout wrap>
            <v-flex
              xs12
              @click="changeRoute(item)"
              :class="
                $route.query.id == item.nameValue
                  ? 'appHeaderActiveClass'
                  : 'appHeaderNormalClass' &&
                    !$route.query.id &&
                    item.nameValue == 'activeCases'
                  ? 'appHeaderActiveClass'
                  : 'appHeaderNormalClass'
              "
              style="
                text-decoration: none;
                cursor: pointer;
                letter-spacing: 0px;
              "
            >
              <span
                :class="
                  $vuetify.breakpoint.name == 'md'
                    ? 'font-size-md'
                    : 'font-size-other'
                "
              >
                {{ item.title }}:
              </span>
              <v-btn
                color="#ededed"
                elevation="0"
                width="25px"
                height="23px"
                fab
                ><span class="pa-1" style="color: #000; font-size: 10px">{{
                  item.value
                }}</span>
              </v-btn>
            </v-flex>
            <v-flex xs12 pt-3>
              <v-progress-linear
                height="5px"
                v-if="
                  $route.query.id == item.nameValue ||
                  (!$route.query.id && item.nameValue == 'activeCases')
                "
                value="100"
                color="#ededed"
              ></v-progress-linear>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-navigation-drawer>
    <!-- APPHEADER -->
    <v-app-bar
      color="transparent"
      dense
      flat
      class="hidden-md-and-up sarpa-topbar"
      height="60px"
    >
      <!--
        Hands the toggle to the layout, which owns the one sidebar. It used to
        drive drawers declared in here against a hard-coded per-role menu: four
        roles had no drawer at all, and the ones that did had drifted from the
        desktop sidebar they were meant to mirror.
      -->
      <v-app-bar-nav-icon @click.native="$emit('toggle-nav')">
        <v-icon color="#1f2a24">mdi-menu</v-icon>
      </v-app-bar-nav-icon>

      <v-spacer></v-spacer>

      <!-- fixed px bounds: a % width here expands and pushes the account button out -->
      <v-img
        contain
        max-width="220"
        height="34"
        src="./../../assets/odisha_2.png"
        class="sarpa-topbar__emblem"
      ></v-img>

      <v-spacer></v-spacer>

      <!-- account / logout has to be reachable on phones too -->
      <AccountMenu v-if="appLogin" />
      <!-- <v-menu left bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on">
            <v-icon color="#000">mdi-dots-vertical</v-icon>
          </v-btn>
        </template>

        <v-card tile flat :elevation="0" max-width="300px">
          <v-layout wrap justify-center py-4>
            <v-flex pt-4 xs12 text-center>
              <span
                style="
                  font-family: poppinssemibold;
                  font-size: 16px;
                  color: #000000;
                "
              >
                Welcome
              </span>
            </v-flex>
            <v-flex pt-2 xs12 text-center>
              <v-icon color="#CCB4B4" size="30">
                mdi-account-circle-outline
              </v-icon>
            </v-flex>
            <v-flex xs12 text-center v-if="appUserrole === 'admin'">
              <router-link to="/Admin/profile">
                <span
                  v-if="appLogin"
                  style="
                    font-family: poppinsmedium;
                    font-size: 13px;
                    color: #1e1b1b;
                    text-transform: uppercase;
                  "
                >
                  <span>
                    {{ appUser }} </span
                  ><br />
                  <span>{{ formattedRole }}</span>
                </span>
              </router-link>
            </v-flex>
            <v-flex xs12 text-center v-if="appUserrole !== 'admin'">
              <router-link to="/Officers/profile">
                <span
                  v-if="appLogin"
                  style="
                    font-family: poppinsmedium;
                    font-size: 13px;
                    color: #1e1b1b;
                    text-transform: uppercase;
                  "
                >
                  <span>
                    {{ appUser }} </span
                  ><br />
                  <span>{{ formattedRole }}</span>
                </span>
              </router-link>
            </v-flex>
            <v-flex xs12 pt-4 text-center>
              <v-btn
                v-if="!appLogin"
                color="#0000001f"
                outlined
                tile
                small
                :ripple="false"
                to="/login"
              >
                <span
                  style="font-family: poppinssemibold; font-size: 14px"
                  class="appColor"
                >
                  LOGIN
                </span>
              </v-btn>
              <v-btn
                v-if="appLogin"
                color="#0000001f"
                outlined
                tile
                small
                :ripple="false"
                @click="appLogout"
              >
                <span
                  style="font-family: poppinssemibold; font-size: 14px"
                  class="appColor"
                >
                  LOGOUT
                </span>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-menu> -->
    </v-app-bar>

    <v-app-bar
      color="transparent"
      dense
      flat
      style="padding-left: 0px !important"
      class="hidden-sm-and-down sarpa-topbar"
      height="66px"
    >
      <!-- 3 equal side columns keep the state emblem optically centred -->
      <v-layout wrap align-center class="px-4">
        <v-flex md3 lg3 align-self-center></v-flex>
        <v-flex md6 lg6 text-center align-self-center>
          <v-img
            contain
            :width="$vuetify.breakpoint.md ? '70%' : '52%'"
            :height="$vuetify.breakpoint.md ? '40%' : '32%'"
            src="./../../assets/odisha_2.png"
            fill-height
            class="sarpa-topbar__emblem"
          ></v-img>
        </v-flex>
        <!-- the trigger is a flex container, so it needs justify-end, not text-right -->
        <v-flex md3 lg3 align-self-center class="d-flex align-center justify-end">
          <AccountMenu v-if="appLogin" />
        </v-flex>
      </v-layout>
    </v-app-bar>
  </div>
</template>
<script>
//WILDWATCH
import axios from "axios";
import AccountMenu from "./accountMenu";
// import AppNotifications from "@/views/Notifications/appNotification";
import Socket from "./../../Sockets/socket";

export default {
  components: {
    // AppNotifications,
    AccountMenu,
  },
  data() {
    return {
      activeSection: localStorage.getItem('activeSection') || 'hwc',
      ServerError: false,
      msg: null,
      showSnackBar: false,
      timeout: 5000,
      searchKey: this.$route.query.searchKey
        ? this.$route.query.searchKey
        : null,
      sideNavRight: false,
      adminItems: [
        {
          title: "Dashboard",
          icon: "mdi-view-dashboard",
          path: "/Admin/admindashboard",
        },
        { title: "My Details", icon: "mdi-account", path: "/Admin/profile" },
        { title: "Public", icon: "mdi-account-group", path: "/Admin/public" },
        {
          title: "Conflict Reports",
          icon: "mdi-source-repository-multiple",
          path: "/Admin/ConflictReports",
        },
        {
          title: "Analytics",
          icon: "mdi-home-analytics",
          path: "/admin/analytics",
        },
        {
          title: "Add Emergency User",
          icon: "mdi-account-plus",
          path: "/Admin/emergencyUser",
        },
        {
          title: "Notifications",
          icon: "mdi-bell",
          path: "/Admin/notifications",
        },
        {
          title: "All Reportings",
          icon: "mdi-file-chart",
          path: "/Admin/myReport",
        },
        {
          title: "Closed Cases",
          icon: "mdi-close",
          path: "/Admin/closedcases",
        },
      ],
      report: {
        title: "Dynamic Data",
        icon: "mdi-folder",
        visible: false,
        reportItems: [
          {
            title: "Scenerios",
            path: "/Admin/dynamicData/scenerios",
          },
          {
            title: "Animals",
            path: "/Admin/dynamicData/animals",
          },
          {
            title: "Animal Activities",
            path: "/Admin/dynamicData/animalActivities",
          },
          {
            title: "Animal Status",
            path: "/Admin/dynamicData/animalStatus",
          },
          {
            title: "Mitigations",
            path: "/Admin/dynamicData/mitigationTypes",
          },
          {
            title: "Land Types",
            path: "/Admin/dynamicData/landTypes",
          },
          {
            title: "Gender",
            path: "/Admin/dynamicData/gender",
          },
          {
            title: "Breach Types",
            path: "/Admin/dynamicData/breachType",
          },
          {
            title: "Barrier Types",
            path: "/Admin/dynamicData/barrierType",
          },
          {
            title: "Conflict Types",
            path: "/Admin/dynamicData/conflictType",
          },
          {
            title: "Crop Types",
            path: "/Admin/dynamicData/cropType",
          },
        ],
      },



      dynamic: [
        {
          title: "Dynamic Data",
          icon: "mdi-folder",
          visible: false,
          items: [
            {
              title: "Scenerios",
              path: "/Admin/dynamicData/scenerios",
            },
            {
              title: "Animals",
              path: "/Admin/dynamicData/animals",
            },
            {
              title: "Animal Activities",
              path: "/Admin/dynamicData/animalActivities",
            },
            {
              title: "Animal Status",
              path: "/Admin/dynamicData/animalStatus",
            },
            // {
            //   title: "Animal Age",
            //   path: "/Admin/dynamicData/animalAge",
            // },
            // {
            //   title: "Veterinary Recommendation",
            //   path: "/Admin/dynamicData/veterinaryRecommendation",
            // },
            {
              title: "Mitigations",
              path: "/Admin/dynamicData/mitigationTypes",
            },
            {
              title: "Land Types",
              path: "/Admin/dynamicData/landTypes",
            },
            {
              title: "Gender",
              path: "/Admin/dynamicData/gender",
            },
            // {
            //   title: "Close Status",
            //   path: "/Admin/dynamicData/closeStatus",
            // },
            // {
            //   title: "Release Types",
            //   path: "/Admin/dynamicData/releaseTypes",
            // },
            {
              title: "Breach Types",
              path: "/Admin/dynamicData/breachType",
            },
            {
              title: "Barrier Types",
              path: "/Admin/dynamicData/barrierType",
            },
            {
              title: "Conflict Types",
              path: "/Admin/dynamicData/conflictType",
            },
            {
              title: "Crop Types",
              path: "/Admin/dynamicData/cropType",
            },
          ],
        },
      ],
      sarpa: {
        title: "SARPA",
        icon: "mdi-snake",
        visible: false,
        sarpaItems: [
          {
            title: "Dashboard",
            path: "/Sarpa/dashboard",
          },
          {
            title: "Add Snakes",
            path: "/addSnakes",
          },
          {
            title: "All Users",
            path: "/usersList",
          },
          {
            title: "New Rescuers",
            path: "/newrescuerslist",
          },
          {
            title: "Rescuer List",
            path: "/allrescuerlist",
          },
          {
            title: "Pending Operations",
            path: "/pendingoperations",
          },
          {
            title: "Assigned Operations",
            path: "/assignedoperations",
          },
          {
            title: "Rescued Operations",
            path: "/rescuedoperations",
          },
          {
            title: "Released Operations",
            path: "/releasedoperations",
          },
          {
            title: "Approved Operations",
            path: "/approvedoperations",
          },
          {
            title: "Delete Operations",
            path: "/deleteoperations",
          },
          {
            title: "Training List",
            path: "/traininglist",
          },
          {
            title: "Snake Reports",
            path: "/snakereports",
          },
          {
            title: "Add Snake Experts",
            path: "/addsnakeexperts",
          },
          {
            title: "Add Hospital",
            path: "/addhospital",
          },
          {
            title: "View Hospital",
            path: "/Viewhospital",
          },
          {
            title: "Identification Help",
            path: "/identificationhelp",
          },
          {
            title: "Approve Hospital",
            path: "/approvehospital",
          },
        ],
      },
    
      //   {
      //     title: "Dashboard",
      //     icon: "mdi-view-dashboard",
      //     path: "/Officers/dashboard",
      //   },
      //   {
      //     title: "My Details",
      //     icon: "mdi-account",
      //     path: "/Officers/myDetails",
      //   },
      //   { title: "Teams", icon: "mdi-account-group", path: "/Officers/teams" },
      //   { title: "Forms", icon: "mdi-form-select", path: "/Officers/forms" },
      //   {
      //     title: "Notifications",
      //     icon: "mdi-bell",
      //     path: "/Officers/notifications",
      //   },
      //   {
      //     title: "Officers",
      //     icon: "mdi-account-circle",
      //     path: "/Officers/officers",
      //   },
      //   {
      //     title: "Merge Cases",
      //     icon: "mdi-call-merge",
      //     path: "/Officers/mergeCases",
      //   },
      //   {
      //     title: "Analytics",
      //     icon: "mdi-home-analytics",
      //     path: "/Officers/analytics",
      //   },
      // ],
      items: [
      {
          title: "Dashboard",
          icon: "mdi-view-dashboard",
          path: "/officers/sarpadashboard",
        },
      ],
      headerItems: [
        {
          title: "Active Cases",
          value: 0,
          path: "/?id=activeCases",
          nameValue: "activeCases",
        },

        {
          title: "Assigned Cases",
          value: 0,
          path: "/?id=assignedCases",
          nameValue: "assignedCases",
        },
        {
          title: "Resolved Cases",
          value: 0,
          path: "/?id=resolvedCases",
          nameValue: "resolvedCases",
        },
        {
          title: "Released Cases",
          value: 0,
          path: "/?id=releasedCases",
          nameValue: "releasedCases",
        },
      ],
      analytics: {},
      mergeValue: null,

      // socket Variables
      // role: null,
      socketType: null,
      newData: {},
      activeCasesvalue: "",
      assignedCasesvalue: "",
      resolvedCasesvalue: "",
    };
  },
  // beforeMount() {
  //   if (this.searchKey) this.appSearch();
  //   else this.getData();
  // },
  mounted() {
    this.socketData();
    if (this.appRole == "admin") {
      console.log("first", this.newData);
      this.assignAnalytics(this.newData);
    }
    // this.getSearch()
  },
  computed: {
    appLogin() {
      return this.$store.state.isLoggedIn;
    },
    appUser() {
      return this.$store.state.userName;
    },

    appUserrole() {
      return this.$store.state.userRole;
    },
    formattedRole() {
      var role = this.appUserrole;
      if (!role) return "";
      var r = String(role).trim();
      var map = {
        medicalofficer: "Medical Officer",
        districtmedicalofficer: "District Medical Officer",
        districtemergencyofficer: "District Emergency Officer",
        disastermanagementofficer: "Disaster Management Officer",
        statemedicalofficer: "State Medical Officer",
        statedisasterofficer: "State Disaster Officer",
        statedisastermanagementofficer: "State Disaster Management Officer",
        emergencyuser: "Emergency User",
        districtmedical: "District Medical Officer"
      };

      var key = r.toLowerCase().replace(/[^a-z]/g, "");
      if (map[key]) return map[key];

      return r
        .replace(/([a-z])([A-Z])/g, "$1 $2")
        .replace(/([A-Z]+)([A-Z][a-z])/g, "$1 $2");
    },
    appRole() {
      return this.$store.state.userRole;
    },
    counterData() {
      return this.$store.state.counterData;
    },
    appNotification() {
      if (this.$store.state.notification == undefined) {
        return 0;
      } else {
        return this.$store.state.notification;
      }
    },
  },
  watch: {
    counterData: {
      handler: function () {
        // console.log(this.storage);
        this.assignAnalytics(this.counterData);
      },
      deep: true,
    },
    // searchKey() {
    //   this.assignAnalytics(this.counterData);
    // },
    // role() {
    //   if (this.role == "official") {
    //     this.assignAnalytics(this.newData)
    //   }
    // },
    //  socketType() {
    //   if (this.socketType == "resolveReport"|| this.socketType == "reportRelease") {
    //     this.assignAnalytics(this.newData)
    //   }
    // },
  },
  sockets: {
    connect() {
      // Fired when the socket connects.
      this.isConnected = true;
    },

    disconnect() {
      this.isConnected = false;
    },

    // Fired when the server sends something on the "messageChannel" channel.
    messageChannel(data) {
      this.socketMessage = data;
    },
  },
  methods: {
    appLogout() {
      this.$store.commit("logoutUser", true);
    },
    // loadData() {
    //   var newData = {};
    //   newData = this.counterData;
    //   console.log(newData, "newData");
    //   this.assignAnalytics(newData);
    // },

    assignAnalytics(analytics) {
      if(analytics.activeCases > 0){
      this.headerItems[0].value = analytics.activeCases;
      }
      else{
      this.headerItems[0].value = 0;
      }
      if(analytics.assignedCases > 0){
        this.headerItems[1].value = analytics.assignedCases;
      }
      else{
        this.headerItems[1].value = 0;
      }
      if(analytics.resolvedCases > 0){
      this.headerItems[2].value = analytics.resolvedCases;
      }
      else{
        this.headerItems[2].value = 0;
      }
      if(analytics.releasedCases > 0){
      this.headerItems[3].value = analytics.releasedCases;
      }
      else{
        this.headerItems[3].value = 0;
      }
    },
    socketData() {
      Socket.countFunction(this); // <---read data
    },
    //WILDWATCH
    getData() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/user/dashboard",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.analytics = response.data.count;
            this.$store.commit("counterData", response.data.count);
            this.assignAnalytics(this.analytics);
            this.$store.commit(
              "changeNotification",
              response.data.unreadNotification
            );
            this.mergeValue = this.analytics.mergeSuggestion;
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.ServerError = true;

          this.appLoading = false;
          console.log(err);
        });
    },
    getDatasearchKey() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/user/dashboard",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data:{
          searchKey: this.searchKey
        }
        
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.analytics = response.data.count;
            this.$store.commit("counterData", response.data.count);
            this.assignAnalytics(this.analytics);
            this.$store.commit(
              "changeNotification",
              response.data.unreadNotification
            );
            this.mergeValue = this.analytics.mergeSuggestion;
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.ServerError = true;

          this.appLoading = false;
          console.log(err);
        });
    },
    changeRoute(item) {
      if (this.$store.state.userRole == "admin") {
        this.$router.push({
          path: "/admin/adminDashboard",
          query: {
            id: this.$route.query.id != item.nameValue ? item.nameValue : null,
            searchKey: this.$route.query.searchKey,
          },
        });
      } else if (
        this.$store.state.userRole == "official" ||
        this.$store.state.userRole == "range" ||
        this.$store.state.userRole == "division" ||
        this.$store.state.userRole == "EmergencyUser" ||
        this.$store.state.userRole == "RRT"
      ) {
        this.$router.push({
          path: "/officers/dashboard",
          query: {
            id: this.$route.query.id != item.nameValue ? item.nameValue : null,
            searchKey: this.$route.query.searchKey,
          },
        });
      }
    },
    appSearch() {
      if (this.$route.query.searchKey == this.searchKey) return;
      this.$router.push({
        path: "",
        query: {
          id: this.$route.query.id,
          searchKey: this.searchKey,
        },
      });
      this.getDatasearchKey();
    },
  },
};
</script>

<style>
.appHeaderActiveClass {
  font-family: sofiaProSemiBold;
  color: #000 !important;
}
.appHeaderNormalClass {
  font-family: sofiaProRegular;
  color: #838383 !important;
}

.v-toolbar__content,
.v-toolbar__extension {
  padding: 4px 0px !important;
}

/* top bar, both breakpoints */
.sarpa-topbar {
  background: linear-gradient(180deg, #ffffff 0%, #f3faf5 100%) !important;
  box-shadow: 0 2px 14px rgba(31, 42, 36, 0.06) !important;
}

.sarpa-topbar__emblem {
  margin: 0 auto;
}

/* ---------- mobile drawer, matched to the desktop sidebar ---------- */
.m-drawer {
  background: linear-gradient(180deg, #162a1c 0%, #0e1b12 100%) !important;
  box-shadow: 4px 0 40px rgba(0, 0, 0, 0.3) !important;
  border-right: none !important;
}

.m-drawer .v-navigation-drawer__content {
  display: flex;
  flex-direction: column;
}

.m-drawer .v-list {
  flex: 1 1 auto;
  overflow-y: auto;
  padding-bottom: 24px !important;
  background: transparent !important;
}

.m-drawer .v-list::-webkit-scrollbar {
  width: 5px;
}

.m-drawer .v-list::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.02);
}

.m-drawer .v-list::-webkit-scrollbar-thumb {
  background: rgba(16, 185, 129, 0.3);
  border-radius: 4px;
}

.m-drawer__header {
  background: #fafafa;
  height: 60px;
  min-height: 60px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.m-drawer .m-nav-item {
  position: relative;
  border-radius: 12px !important;
  padding: 0 16px !important;
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1) !important;
}

.m-drawer .m-nav-item::before {
  opacity: 0;
}

.m-drawer .m-nav-icon {
  color: #a7f3d0 !important;
}

.m-drawer .m-nav-title {
  color: #e6f4ea !important;
  font-size: 14px;
  font-family: poppinsmedium;
  letter-spacing: 0.43px;
}

.m-drawer .m-nav-item:hover {
  background: rgba(52, 211, 153, 0.12) !important;
}

.m-drawer .m-nav-item--active {
  background: linear-gradient(135deg, #10b981, #059669) !important;
  box-shadow: 0 6px 16px rgba(16, 185, 129, 0.25) !important;
}

.m-drawer .m-nav-item--active .m-nav-icon,
.m-drawer .m-nav-item--active .m-nav-title {
  color: #ffffff !important;
  font-weight: 600;
}

.font-size-md {
  font-size: 12px;
}
.font-size-other {
  font-size: 16px;
}
</style>

